export const ERROR_MESSAGE = 'Error fetching Dinghy events. Did you remember to enable the `services.dinghy.enabled` flag in Gate\'s profile?.';
export const NO_EVENTS_FOUND = 'No records found in the past 24 hours.';
